import { PaletteMode } from '@mui/material';
import { GetThemeOptions } from '../../theme';
import { ChronosphereColorPalette, green } from '../colors';
import { buildPaletteForMode, type Token } from '../panw-palette/token-metadata';

const primaryColorTokens = [
  { propertyPath: 'main', tokenName: '--primary-color-main' },
  { propertyPath: 'highContrast', tokenName: '--primary-color-high-contrast' },
  { propertyPath: 'lowContrast', tokenName: '--primary-color-low-contrast' },
] satisfies Token[];

export const primaryColor = (mode: PaletteMode, opts: GetThemeOptions): ChronosphereColorPalette => {
  if (opts.panwRebrandStubYear) {
    return buildPaletteForMode<ChronosphereColorPalette>(primaryColorTokens, mode);
  }
  return mode === 'light'
    ? {
        main: green[600],
        highContrast: green[800],
        lowContrast: green[150],
      }
    : {
        main: green[500],
        highContrast: green[300],
        lowContrast: green[700],
      };
};
